import type { Messages } from "@prop/i18n";
import type en from "../en/risk";

export default {
  tabs: { programs: "Программы", risk: "Риск-монитор", breaches: "Нарушения", approvals: "Согласования", fairplay: "Честная торговля", news: "Новости" },
  markets: { fx: "FX / CFD", futures: "Фьючерсы", crypto: "Крипто" },
  programs: {
    name: "Программа",
    market: "Рынок",
    published: "Опубликована",
    draft: "Черновик",
    accounts: "Аккаунты",
    none: "—",
    back: "Все программы",
    versions: "Версии",
    version: "v{n}",
    status: { draft: "черновик", published: "опубликована", retired: "снята с продажи" },
    editDraft: "Изменить как новый черновик",
    editor: "Черновик следующей версии",
    frozenNote: "Опубликованная версия не меняется. Купленные аккаунты остаются на своей версии.",
    accountSize: "Размер счёта, $",
    price: "Цена, $",
    listPrice: "Цена без скидки, $",
    launchPricing: "Стартовая цена",
    dayBoundary: "Торговый день заканчивается в",
    timezone: "Часовой пояс",
    cmeSession: "Сессия CME (17:00 Чикаго)",
    leverage: "Плечо",
    phase: "Фаза {n}: {name}",
    funded: "Funded",
    target: "Цель по прибыли, %",
    dll: "Дневной убыток, %",
    dllBase: "База дневного убытка",
    bases: { initial: "Начальный баланс", day_start_balance: "Баланс на начало дня", day_start_equity: "Equity на начало дня", max_day_start_balance_equity: "Максимум из баланса и equity на начало дня" },
    dllAction: "При дневном убытке",
    actions: { fail: "Провал аккаунта", pause_until_next_day: "Пауза до следующего дня" },
    ml: "Максимальный убыток, %",
    mlMode: "Тип максимального убытка",
    modes: { static: "Статичный", trailing_eod: "Трейлинг по концу дня", trailing_intraday_balance: "Трейлинг по балансу внутри дня", trailing_equity_hwm: "Трейлинг по максимуму equity" },
    lock: "Трейлинг останавливается на стартовом балансе",
    minDays: "Минимум торговых дней",
    microHold: "Микроскальпинг: сделки короче, с",
    microShare: "Доход микроскальпинга, макс. % прибыли",
    streakDays: "Выплата: прибыльных дней подряд",
    streakPct: "Каждый такой день не меньше, % от аккаунта",
    streakConsecutive: "Эти дни должны идти подряд",
    consistency: "Лучший день ≤ % прибыли",
    split: "Доля трейдера, %",
    json: "Все правила (JSON)",
    jsonInvalid: "JSON с ошибкой: {error}",
    saveDraft: "Сохранить черновик",
    saved: "Черновик сохранён",
    diff: "Изменения относительно опубликованной версии",
    noChanges: "Изменений нет",
    publish: "Опубликовать",
    publishConfirm: "Опубликовать версию {n}? Она станет неизменяемой и пойдёт в продажу; прошлая версия снимается с продажи.",
    publishedOk: "Версия {n} опубликована",
    create: "Новая программа",
    slug: "Код (a-z, 0-9, -)",
    family: "Семейство",
    billing: "Оплата",
    billings: { one_time: "Разово", monthly: "Ежемесячно" },
    preview: "Кратко",
    summary: {
      target: "Цель {v}",
      dll: "дневной убыток {v} ({base}, {action})",
      ml: "макс. убыток {v} ({mode})",
      days: "{n} торговых дней",
      daysBar: "{n} торговых дней с прибылью ≥ {v} %",
      tradeLoss: "убыток одной сделки ≤ {v}, открытой или закрытой",
      window: "{h} ч с первой сделки",
      duration: "срок {n} дн.",
      maxDays: "не больше {n} торговых дней",
      inactivity: "{n} дн. без сделок — счёт закрывается",
      contracts: "до {n} контрактов на инструмент",
      flat: "позиции закрываются в {time}",
      weekend: "позиции FX / CFD закрываются в пт 16:55 Нью-Йорк",
      news: "без новых сделок ±{n} мин от важных новостей",
      consistency: "лучший день ≤ {v} %",
      microScalp: "сделки короче {sec} с ≤ {v} % прибыли",
      streak: "выплата после {n} прибыльных дней подряд, каждый ≥ {v}",
      payouts: "Выплаты",
      split: "доля {v} %",
    },
  },
  monitor: {
    title: "Аккаунты по близости к нарушению",
    account: "Аккаунт",
    trader: "Трейдер",
    phase: "Фаза",
    status: "Статус",
    equity: "Equity",
    dllLeft: "Остаток дневного лимита",
    mlLeft: "Остаток макс. лимита",
    used: "Использовано лимита",
    empty: "Пока нет челлендж- и funded-аккаунтов",
  },
  states: {
    created: "создан",
    active: "активен",
    paused: "пауза до конца дня",
    phase_passed: "фаза пройдена",
    pending_review: "на проверке",
    kyc_required: "нужен KYC",
    funded_pending: "оформление funded",
    funded: "funded",
    breached: "нарушение",
    failed: "провален",
    expired: "истёк",
    suspended: "приостановлен",
    closed: "закрыт",
    refunded: "возврат",
  },
  rules: { max_loss: "Максимальный убыток", daily_loss: "Дневной убыток", consistency: "Стабильность", max_duration: "Срок", inactivity: "Неактивность", max_trade_loss: "Убыток одной сделки", max_trading_days: "Исчерпаны торговые дни" },
  card: {
    back: "Назад",
    risk: "Риск сейчас",
    balance: "Баланс",
    equity: "Equity",
    dll: "Дневной лимит",
    ml: "Порог макс. убытка",
    target: "Цель",
    days: "Торговые дни",
    breaches: "Нарушения",
    noBreaches: "Нарушений нет",
    threshold: "Порог",
    observed: "Наблюдение",
    source: "Источник цены",
    positions: "Позиции в момент решения",
    timeline: "История состояний",
    replay: "Replay",
    replayRun: "Повторить по правилам аккаунта",
    whatIf: "What-if",
    whatIfDll: "Дневной убыток, %",
    whatIfMl: "Макс. убыток, %",
    whatIfRun: "Повторить с этими правилами",
    outcome: { breached: "Нарушение", passed: "Пройдено", open: "Решения нет" },
    observations: "Записанных наблюдений: {n}",
    manual: "Ручное действие",
    event: "Действие",
    events: { suspend: "Приостановить", unsuspend: "Возобновить", reinstate_from_breach: "Восстановить после нарушения (второе согласование)", force_pass: "Засчитать фазу (второе согласование)", close: "Закрыть", penalty_reset: "Сбросить со штрафом 50 % выплат" },
    penaltyDone: "Сброшен: новый счёт {id}, выплаты 50 %",
    submit: "Отправить",
    pending: "Отправлено на второе согласование",
    reinstateHint: "Восстановление не правит баланс. После нарушения макс. или дневного убытка счёт снова нарушит правило на следующей проверке, если не указать здесь поправку (только при ошибке платформы).",
    adjustment: "Поправка баланса, USD (необязательно, + или −)",
    adjustmentReason: "Причина поправки",
  },
  approvals: {
    title: "Заявки «четыре глаза»",
    account: "Аккаунт",
    action: "Действие",
    reason: "Причина",
    requestedBy: "Запросил",
    status: "Статус",
    approve: "Одобрить",
    reject: "Отклонить",
    statuses: { pending: "ожидает", approved: "одобрена", rejected: "отклонена", executed: "исполнена" },
    ownRequest: "Ваша заявка — одобряет другой сотрудник",
    adjustment: "поправка {v}",
    empty: "Заявок нет",
  },
  news: {
    title: "Календарь новостей",
    lead: "Важные события открывают новостное окно в программах, где оно есть (FX / CFD funded: ±2 мин): нельзя открыть или увеличить позицию по инструментам отмеченных валют и рынков; закрыть можно всегда. Движок перечитывает календарь каждые 30 с.",
    at: "Время (ваш часовой пояс)",
    name: "Событие",
    tags: "Валюты / рынки",
    tagsHint: "через запятую: USD, EUR, XAU",
    impact: "Важность",
    add: "Добавить событие",
    save: "Сохранить",
    cancel: "Отмена",
    edit: "Изменить",
    remove: "Удалить",
    empty: "Событий на 30 дней нет",
    impacts: { high: "высокая", medium: "средняя", low: "низкая" },
  },
  fairplay: {
    title: "Встречные позиции на связанных счетах",
    lead: "Лонг на одном счёте и шорт на другом в одном инструменте в одно время — у одного человека, у людей с одним документом или из одной сети. Хеджирование между счетами запрещено: отклоняйте выплату как нарушение правил.",
    days: "Период",
    instrument: "Инструмент",
    long: "Лонг",
    short: "Шорт",
    links: "Связь",
    gap: "Разница открытия",
    overlap: "Пересечение",
    open: "открыта",
    empty: "За этот период встречных позиций на связанных счетах нет",
    link: { same_person: "один человек", same_document: "один документ", shared_ip: "одна сеть" },
  },
} satisfies Messages<typeof en>;
